import{jsx as e}from"react/jsx-runtime";import{memo as o}from"react";import{styled as t}from"styled-components";import{BodyCell as r}from"./Cell.mjs";import{RowSelectionContextProvider as n}from"./RowSelectionContext.mjs";import{cellClassName as l,bodyCellStyle as d,selectedCellColor as i,oddRowCellColor as c,evenRowCellColor as m}from"./style.mjs";import{FormField as s}from"../../base/Form/FormField.mjs";import{useLocalizedContents as a}from"../../../../messages/context/LocalizedContentsContext.mjs";const p=t.div`
  display: contents;
  & {
    .cell.checked.odd,
    .cell.checked.even {
      ${i()}
    }
    .odd {
      ${c(!1)}
    }
    .odd.frozen {
      ${c(!0)}
    }
    .even {
      ${m(!1)}
    }
    .even.frozen {
      ${m(!0)}
    }
    &:hover {
      .cell {
        background: #29b2a4 !important;
        border-top: 1px solid #a8d8eb !important;
        border-bottom: 1px solid #a8d8eb !important;
        border-right: 1px solid #cccccc !important;
      }
    }
  }
`,w=t(s)`
  overflow: hidden;
  margin: 0;
  line-height: 22px;
`;const f=o((function({viewportColumns:o,row:t,setRow:i,onAdd:c,onDelete:m,onDoubleClick:s,onCopy:f,rowIndex:h,selectedRows:x,setSelectedRows:u,rowKeyGetter:C,errorFields:b,rowRef:v,singleSelect:g}){const{locale:F,dateFormat:k,dateTimeFormat:y}=a(),R=C?null==x?void 0:x.has(C(t)):void 0,j=()=>{if(u&&x&&C){const e=C(t);let o=new Set(x);x.has(e)?o.delete(e):g?o=new Set([e]):o.add(e),u(o)}};return e(n,{value:{checked:R,onChange:j},children:e(p,{onClick:j,onDoubleClick:()=>null==s?void 0:s(t),className:"grid-row",children:o.map((o=>{const{index:n,renderCell:s,frozen:a,textAlign:p}=o;return e(r,{$textAlign:p,style:d(o,h),className:l(h,a,null!=R&&R),children:e(w,{children:s({row:t,setRow:i,rowIndex:h,onAdd:c,onDelete:m,onCopy:f,errorFields:b,rowRef:v,locale:F,dateFormat:k,dateTimeFormat:y})})},n)}))},h)})}));export{f as Row};
